// React
import React from 'react';
import ReactDOM from 'react-dom/client';

// Components
import App from './components/App.js';

// Style
import './styles/fonts.js';
import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App/>
	</React.StrictMode>
);
